import { render } from "./ItemForm.vue?vue&type=template&id=b94a7dfa&scoped=true"
import script from "./ItemForm.vue?vue&type=script&lang=js"
export * from "./ItemForm.vue?vue&type=script&lang=js"

import "./ItemForm.vue?vue&type=style&index=0&id=b94a7dfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94a7dfa"]])

export default __exports__